import { apiRecords } from "./workerApi";
import { pb } from "./pocketbaseConfig";

// Raw shape requested from PocketBase (see `fields` param below) before mapping to `Campaign`.
export interface CampaignRecord {
  id: string;
  collectionId: string;
  collectionName: string;
  storeId?: string;
  storeName?: string;
  storeAlias?: string;
  campaignId?: string;
  startDate?: string;
  endDate?: string;
  currentCampaign?: boolean;
  created?: string;
  pageDownloadUrl?: string;
  pageDownloadUrlAvif?: string;
  pageDownloadUrlAvifMobile?: string;
  pageWidth?: number;
  pageHeight?: number;
}

// Restricts the PocketBase response to only the fields used by this component.
export const CAMPAIGN_FIELDS =
  "id,collectionId,collectionName,storeId,storeAlias,storeName,campaignId,pageDownloadUrl,pageDownloadUrlAvif,pageDownloadUrlAvifMobile,pageWidth,pageHeight,startDate,endDate,currentCampaign,created";

export function buildPremiumCampaignFilter(includeHidden = false) {
  const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
  const nextWeek = new Date();
  nextWeek.setDate(nextWeek.getDate() + 7);
  const base = `profile="premium" && pageId="thumbnail" && currentCampaign=true && endDate > "${yesterday}" && startDate <= "${nextWeek.toISOString()}" && status="inProgress"`;
  return includeHidden ? base : `${base} && isHidden != true`;
}

let initialRequest: Promise<{ items: CampaignRecord[]; filter: string }> | undefined;
let startedAt = 0;

// Short-lived, public-only request shared by startup and the mobile homepage.
export function getInitialMobileHomepageCampaigns() {
  if (!initialRequest || Date.now() - startedAt > 30000) {
    startedAt = Date.now();
    const filter = buildPremiumCampaignFilter();
    const request = apiRecords("campaigns").getList<CampaignRecord>(1, 20, {
      filter, sort: "-created", skipTotal: true, fields: CAMPAIGN_FIELDS,
    }).then(({ items }) => ({ items, filter }));
    initialRequest = request;
    void request.catch(() => {
      if (initialRequest === request) initialRequest = undefined;
    });
  }
  return initialRequest;
}

export function primeMobileHomepageCampaigns() {
  if (window.location.pathname !== "/" || window.innerWidth > 640) return;
  void getInitialMobileHomepageCampaigns().catch(() => {
    // The component retries normally if startup prefetch fails.
  });
}
